import React from "react";
import Logo from "../../assets/elala//elala.png";
function Footer() {
  return (
    <footer className="footer-bg footer_margin">
      <div className="container">
        <div className="row footer-part">
          <div className="col-md-4">
            <div className="elala_logo">
              <a href="/" className="active">
                <img src={Logo} alt="" />
              </a>
            </div>
            <div className="mt-3" style={{ paddingRight: "60px" }}>
              <p className="footer_paragraph">
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
            </div>
          </div>
          <div className="col-md-2">
            <ul className="">
              <li>
                <span className="footer-heading">About eLala</span>
              </li>
              <li>
                <a href="/about_us">About</a>
              </li>
              <li>
                <a href="/news_feed">Newsfeed</a>
              </li>
              <li>
                <a href="/">My Account</a>
              </li>
              <li>
                <a href="/contact_us">Contact</a>
              </li>
            </ul>
          </div>
          <div className="col-md-3">
            <ul className="">
              <li>
                <span className="footer-heading">Useful Links</span>
              </li>
              <li>
                <a href="/privacy">Privacy</a>
              </li>
              <li>
                <a href="/terms">Terms & Conditions</a>
              </li>
              <li>
                <a href="/help">Help</a>
              </li>
            </ul>
          </div>
          <div className="col-md-3">
            <ul className="">
              <li>
                <span className="footer-heading">Join Our Newsletter Now</span>
              </li>
              <li>
                <div className="newsletter-form d-flex">
                  <input
                    type="email"
                    className="form-control input_placeholder_part"
                    id="exampleInputEmail1"
                    placeholder="Name"
                    aria-describedby="emailHelp"
                  />
                  <button type="submit" className="submit_btn">
                    Submit
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="row py-3 py-lg-4 footer-copyright px-3 px-md-0">
          <div className="col-md-9 col-lg-8 px-0">
            <ul>
            <li>
              <a href="#">
                <span>Copyright © {new Date().getFullYear()} Exp Life Private Limited</span>
              </a>
            </li>

            </ul>
          </div>
          <div className="col-md-3 col-lg-4 text-center text-md-end pe-0">
            <div>
              <span className="mx-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1332_1634)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.02501 1.255C6.85589 1.21675 7.12081 1.20825 9.23731 1.20825C11.3538 1.20825 11.6187 1.21746 12.4489 1.255C13.2791 1.29254 13.8457 1.425 14.3416 1.61696C14.8608 1.81317 15.3318 2.11988 15.7214 2.51654C16.1181 2.90542 16.4241 3.37575 16.6196 3.89567C16.8122 4.3915 16.944 4.95817 16.9822 5.78692C17.0205 6.61921 17.029 6.88413 17.029 8.99992C17.029 11.1164 17.0198 11.3813 16.9822 12.2122C16.9447 13.041 16.8122 13.6076 16.6196 14.1035C16.424 14.6234 16.1175 15.0946 15.7214 15.484C15.3318 15.8807 14.8608 16.1867 14.3416 16.3822C13.8457 16.5748 13.2791 16.7066 12.4503 16.7448C11.6187 16.7831 11.3538 16.7916 9.23731 16.7916C7.12081 16.7916 6.85589 16.7824 6.02501 16.7448C5.19626 16.7073 4.6296 16.5748 4.13376 16.3822C3.61379 16.1866 3.14268 15.8801 2.75322 15.484C2.35682 15.0949 2.05007 14.624 1.85435 14.1042C1.66239 13.6083 1.53064 13.0417 1.49239 12.2129C1.45414 11.3806 1.44564 11.1157 1.44564 8.99992C1.44564 6.88342 1.45485 6.6185 1.49239 5.78834C1.52993 4.95817 1.66239 4.3915 1.85435 3.89567C2.05036 3.37581 2.35735 2.90493 2.75393 2.51584C3.14283 2.11952 3.61347 1.81277 4.13306 1.61696C4.62889 1.425 5.19556 1.29325 6.02431 1.255H6.02501ZM12.3858 2.6575C11.5642 2.61996 11.3177 2.61217 9.23731 2.61217C7.15693 2.61217 6.91043 2.61996 6.08876 2.6575C5.32872 2.69221 4.91647 2.819 4.64164 2.92596C4.27826 3.06763 4.01831 3.2355 3.7456 3.50821C3.48709 3.75971 3.28814 4.06587 3.16335 4.40425C3.05639 4.67909 2.9296 5.09134 2.89489 5.85138C2.85735 6.67304 2.84956 6.91954 2.84956 8.99992C2.84956 11.0803 2.85735 11.3268 2.89489 12.1485C2.9296 12.9085 3.05639 13.3208 3.16335 13.5956C3.28801 13.9335 3.48706 14.2402 3.7456 14.4916C3.99706 14.7502 4.30376 14.9492 4.64164 15.0739C4.91647 15.1808 5.32872 15.3076 6.08876 15.3423C6.91043 15.3799 7.15622 15.3877 9.23731 15.3877C11.3184 15.3877 11.5642 15.3799 12.3858 15.3423C13.1459 15.3076 13.5581 15.1808 13.833 15.0739C14.1963 14.9322 14.4563 14.7643 14.729 14.4916C14.9876 14.2402 15.1866 13.9335 15.3113 13.5956C15.4182 13.3208 15.545 12.9085 15.5797 12.1485C15.6173 11.3268 15.6251 11.0803 15.6251 8.99992C15.6251 6.91954 15.6173 6.67304 15.5797 5.85138C15.545 5.09134 15.4182 4.67909 15.3113 4.40425C15.1696 4.04088 15.0017 3.78092 14.729 3.50821C14.4775 3.24972 14.1713 3.05078 13.833 2.92596C13.5581 2.819 13.1459 2.69221 12.3858 2.6575ZM8.2421 11.4019C8.7979 11.6332 9.41678 11.6645 9.99305 11.4902C10.5693 11.316 11.0672 10.9471 11.4017 10.4465C11.7362 9.94595 11.8865 9.34478 11.827 8.7457C11.7675 8.14662 11.5019 7.58677 11.0754 7.16179C10.8036 6.89013 10.4749 6.68212 10.113 6.55273C9.75117 6.42334 9.36511 6.3758 8.98266 6.41352C8.6002 6.45124 8.23087 6.57329 7.90125 6.77089C7.57163 6.96848 7.28992 7.2367 7.07639 7.55623C6.86287 7.87576 6.72286 8.23866 6.66642 8.61881C6.60999 8.99895 6.63854 9.38688 6.75002 9.75466C6.8615 10.1224 7.05315 10.4609 7.31115 10.7458C7.56915 11.0306 7.8871 11.2547 8.2421 11.4019ZM6.40539 6.168C6.77728 5.79611 7.21878 5.50111 7.70468 5.29984C8.19058 5.09857 8.71137 4.99498 9.23731 4.99498C9.76324 4.99498 10.284 5.09857 10.7699 5.29984C11.2558 5.50111 11.6973 5.79611 12.0692 6.168C12.4411 6.53989 12.7361 6.9814 12.9374 7.4673C13.1386 7.9532 13.2422 8.47398 13.2422 8.99992C13.2422 9.52585 13.1386 10.0466 12.9374 10.5325C12.7361 11.0184 12.4411 11.4599 12.0692 11.8318C11.3182 12.5829 10.2995 13.0049 9.23731 13.0049C8.17513 13.0049 7.15646 12.5829 6.40539 11.8318C5.65432 11.0808 5.23237 10.0621 5.23237 8.99992C5.23237 7.93774 5.65432 6.91907 6.40539 6.168ZM14.1305 5.59142C14.2226 5.50448 14.2964 5.39994 14.3474 5.28398C14.3985 5.16802 14.4257 5.043 14.4276 4.91633C14.4294 4.78965 14.4058 4.66389 14.3582 4.54649C14.3106 4.42909 14.2399 4.32245 14.1503 4.23286C14.0607 4.14328 13.954 4.07258 13.8366 4.02495C13.7193 3.97732 13.5935 3.95373 13.4668 3.95558C13.3401 3.95743 13.2151 3.98467 13.0992 4.0357C12.9832 4.08673 12.8787 4.16051 12.7917 4.25267C12.6227 4.4319 12.5301 4.66996 12.5337 4.91633C12.5373 5.16269 12.6367 5.39796 12.811 5.57218C12.9852 5.74641 13.2204 5.84587 13.4668 5.84946C13.7132 5.85306 13.9512 5.76049 14.1305 5.59142Z"
                      fill="#686363"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1332_1634">
                      <rect
                        width="17"
                        height="17"
                        fill="white"
                        transform="translate(0.737305 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span className="mx-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="18"
                  viewBox="0 0 9 18"
                  fill="none"
                >
                  <path
                    d="M2.84656 17.5V9.52311H0.737305V6.65104H2.84656V4.19793C2.84656 2.27024 4.09251 0.5 6.96343 0.5C8.12583 0.5 8.98536 0.611435 8.98536 0.611435L8.91764 3.29346C8.91764 3.29346 8.04105 3.28492 7.08447 3.28492C6.04917 3.28492 5.88331 3.76203 5.88331 4.55391V6.65104H8.99993L8.86432 9.52311H5.88331V17.5H2.84656Z"
                    fill="#686363"
                  />
                </svg>
              </span>
              <span className="mx-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="18"
                  viewBox="0 0 17 18"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1332_1638)">
                    <path
                      d="M16.7471 3.99695C16.1556 4.25904 15.5202 4.43612 14.8523 4.51616C15.5415 4.10377 16.0571 3.4547 16.3029 2.69008C15.6554 3.0747 14.9467 3.34543 14.2077 3.4905C13.7107 2.95986 13.0524 2.60814 12.3351 2.48996C11.6177 2.37177 10.8814 2.49372 10.2405 2.83688C9.59954 3.18004 9.08983 3.72521 8.79047 4.38774C8.49111 5.05028 8.41886 5.79311 8.58494 6.50091C7.27289 6.43503 5.98935 6.09401 4.81762 5.49997C3.64589 4.90593 2.61216 4.07215 1.78353 3.05275C1.50019 3.5415 1.33728 4.10816 1.33728 4.71166C1.33696 5.25495 1.47075 5.78992 1.72677 6.2691C1.9828 6.74828 2.35314 7.15686 2.80494 7.45858C2.28097 7.44191 1.76856 7.30033 1.31036 7.04562V7.08812C1.31031 7.8501 1.57388 8.58864 2.05636 9.17841C2.53885 9.76818 3.21051 10.1729 3.9574 10.3238C3.47133 10.4553 2.96172 10.4747 2.46707 10.3805C2.67779 11.0361 3.08827 11.6094 3.64104 12.0202C4.1938 12.431 4.86118 12.6586 5.54973 12.6712C4.38087 13.5888 2.93732 14.0865 1.45132 14.0843C1.18809 14.0844 0.92508 14.069 0.663651 14.0383C2.17203 15.0081 3.92789 15.5228 5.72115 15.5208C11.7916 15.5208 15.1101 10.4931 15.1101 6.13258C15.1101 5.99091 15.1066 5.84783 15.1002 5.70616C15.7457 5.23935 16.3029 4.6613 16.7457 3.99908L16.7471 3.99695Z"
                      fill="#686363"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1332_1638">
                      <rect
                        width="17"
                        height="17"
                        fill="white"
                        transform="translate(-6.10352e-05 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
